/*
 * Capabilities — content for the CapabilitiesHomeTwo section (homepage).
 *
 * Redesigned 2026-05-26 to the "Core Capabilities / Measurable Outcomes"
 * reference: 6 cards, each a media graphic on top + title + description.
 * Display order (set 2026-05-27): Brand Intelligence, Digital Care,
 * Competitive Intelligence, Crisis Management, Market Research, AI & Automation.
 *
 * Shape:
 *   id     — stable string, React key + image slug
 *   title  — card heading
 *   desc   — card body copy
 *   image  — per-card graphic in /public (user supplies the art; until then
 *            the card shows a pale placeholder box, matching the mock)
 */

export const CAPABILITIES = [
  {
    id: 'brand-intelligence',
    title: 'Brand Intelligence',
    desc: 'Stay ahead of perception shifts with real-time visibility into brand health, campaign impact, and share-of-voice — before conversations turn into trends.',
    image: '/capabilities/brandintellidence.webp',
  },
  {
    id: 'digital-care',
    title: 'Digital Care',
    desc: 'Resolve customer issues faster across every channel with AI-powered routing and a unified inbox built for seamless support operations.',
    image: '/capabilities/digitalcare.webp',
  },
  {
    id: 'competitive-intelligence',
    title: 'Competitive Intelligence',
    desc: 'Benchmark rivals, strengthen your competitive positioning, and spot market opportunities before competitors do.',
    image: '/capabilities/competitive.webp',
  },
  {
    id: 'crisis-management',
    title: 'Crisis Management',
    desc: 'Identify emerging risks instantly, activate the right response teams, and contain brand damage before it escalates.',
    image: '/capabilities/crisis.webp',
  },
  {
    id: 'market-research',
    title: 'Market Research',
    desc: 'Turn customer conversations into strategic decisions with real-time sentiment, trend prediction, and audience intelligence.',
    image: '/capabilities/market%20research.webp',
  },
  {
    id: 'ai-automation',
    title: 'AI & Automation',
    desc: 'Accelerate support efficiency with DIY workflows that automate responses, assignments, and surveys using intelligent, condition-based triggers with AI.',
    image: '/capabilities/workflow.webp',
  },
];
